/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TagText/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TagText({
  children,
  viewPath = "/DesignSystem/TagText",
  backgroundColor = "rgba(0,188,112,0.2)",
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  paddingBottom = 12,
  paddingLeft = 12,
  paddingRight = 12,
  paddingTop = 12,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  onClick,
  goTo,
  borderColor = "#ebebeb",
  borderWidth = 0,
  justifyContent = "flex-start",
  cursor,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="TagText.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-8lvKF': backgroundColor,'--bblr-2-8lvKF': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-8lvKF': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-8lvKF': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-8lvKF': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--pb-6-8lvKF': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-7-8lvKF': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-8-8lvKF': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-9-8lvKF': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--ml-10-8lvKF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-11-8lvKF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-12-8lvKF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-13-8lvKF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--bc-14-8lvKF': borderColor,'--bw-15-8lvKF': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--jc-16-8lvKF': justifyContent,'--c-17-8lvKF': cursor}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</a>
</React.Fragment>)
}